// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "/api/v1/admin/auth/login",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: "/api/v1/admin/auth/forgot-password",
        method: "POST",
        body: { ...data },
      }),
    }),
    resetPassword: builder.mutation({
      query: ({ token, ...data }) => ({
        url: `/api/v1/admin/auth/reset-password/${token}`,
        method: "PATCH",
        body: { ...data },
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: "/api/v1/admin/auth/logout",
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
} = authApiSlice;
